import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ImgPlaceHolder from "../../constant/imgPlaceholder";
import { doctorAction } from "../../redux/action";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import WaitScreen from "../LodingScreen/WaitScreen";
import SeoAdd from "../Seo/SeoAdd";

function Team() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const dData:any = useSelector((state:any) => state.doctor.list ? state.doctor.list : {});
  const doctorList:any = useSelector((state:any) => state.doctor.list?.Doctors ? state.doctor.list?.Doctors : {});

  useEffect(() => {
    window?.scrollTo(0, 0);
    dispatch(doctorAction.listDoctorAction({DepartmentId:""}));
    return () => {}
  }, []);

  return (
    <>
    <SeoAdd slug={ROUTE.TEAM}/>
    {dData && Object.keys(dData).length <1 && <WaitScreen/>}
    <BreadCrumb page={"Meet our team"} data={{slug: "", path: "#"}}/>
    <section className="team-section">
      <div className="container">
        <div className="text-center"><img className="scale" src={t("images.team_banner")} alt="" /></div>
        <div className="tab-content">
          <div className="mt-25 text-center">
            <h2>Meet our Experts</h2>
            <div className="mt-25">
              <p className="text-center dull_heading pb-3">
                Oncquest Laboratories Ltd has a two-decade legacy of trust and
                accuracy in pathology testing.
              </p>
            </div>
          </div>
          {doctorList && 
          <div className="equal_clm h-services">
            {doctorList && doctorList?.length >0 && doctorList?.map((item:any, i:any)=> (
              <div className="doc_infobox_wrapper doc_span" key={i}>
              <div className="pointer mt-25">
                <div className="">
                  <div className="doc_infobox_icon_container text-center">
                    <img src={item?.ProfileImage ? item?.ProfileImage : "/assets/img/doctor1.png"} onError={(e:any)=> ImgPlaceHolder(e, "/assets/img/doctor1.png")} className="doc_scale" />
                  </div>
                  <h6 className="text-center">{item?.Name}</h6>
                  <p className="text-center mt-10 gray">
                   {item?.Designation} {item?.Designation && item?.DepartmentName && " - "} {item?.DepartmentName}
                  </p>
                </div>
                <div className="doc_contact">
                  <h6 className="text-center white">
                  {item?.Name}
                  </h6>
                  <p className="text-center mt-10 white">
                  {item?.Designation} {item?.Designation && item?.DepartmentName && " - "} {item?.DepartmentName}
                  </p>
                  <p className="text-center">
                      <Link to={`${ROUTE.DOCTORDETAILS}/${item?.DoctorCode}`} className="mt-2 team normal button--hexagon">
                        <span>{t("know_more")}</span>
                      </Link>
                    </p>
                </div>
              </div>
            </div>
            ))}
          </div>}
        </div>
      </div>
    </section>
    </>
  );
}

export default Team;
